<div class="sp-dialog__max-width-s sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__primary">{{ 'VOP_REQUEST.FILTER_CTA' | translate }}:</h3>
    <form
      [formGroup]="vop_requests_filters_from_group"
      class="sp-margin__top-x2 sp-row__space sp-wrap">
      <mat-form-field
        class="sp-width__full"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'VOP_REQUEST.ID_COLUMN_LABEL' | translate }} </mat-label>
        <input
          matInput
          type="text"
          formControlName="vop_request_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'VOP_REQUEST.STATUS_LABEL' | translate }}
        </mat-label>
        <mat-select
          formControlName="status"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="succeeded">
            {{ getVopRequestStatusLabel(succeeded) | translate }}
          </mat-option>
          <mat-option [value]="pending">
            {{ getVopRequestStatusLabel(pending) | translate }}
          </mat-option>
          <mat-option [value]="failed">
            {{ getVopRequestStatusLabel(failed) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'VOP_REQUEST.RESULT' | translate }}
        </mat-label>
        <mat-select
          formControlName="result"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="MTCH"> MTCH </mat-option>
          <mat-option [value]="CMTC"> CMTC </mat-option>
          <mat-option [value]="NMTC"> NMTC </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'VOP_REQUEST.BENEFICIARY_FIRSTNAME_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="beneficiary_firstname"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'VOP_REQUEST.BENEFICIARY_LASTNAME_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="beneficiary_lastname"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'VOP_REQUEST.BENEFICIARY_TAX_CODE_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="beneficiary_tax_code"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'VOP_REQUEST.BENEFICIARY_IBAN' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="beneficiary_iban"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'VOP_REQUEST.BUYER_ID' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="buyer_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'VOP_REQUEST.ORDER_ID' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="order_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <div class="sp-row__end sp-width__full sp-margin__top">
        <p
          (click)="onClearFiltersClick()"
          class="p-color__accent sp-text__right sp-text__hover">
          {{ 'GENERAL.CLEAR_FILTERS_CTA' | translate }}
        </p>
      </div>

      <div class="sp-margin__top-x4 sp-width__full">
        <app-shared-button
          class="sp-width__full"
          [cta]="'GENERAL.APPLY_FILTERS_CTA'"
          [is_disabled]="!isFormValid()"
          (button_click)="onApplyFiltersClick()"></app-shared-button>
      </div>
    </form>
  </div>
</div>
